import './css/app.css';
import 'utils/lazysizes';
import 'vendor/trustpilot';

import { picoapp } from 'picoapp';
import ready from 'utils/ready';

import header from 'layout/header';
import announcementBar from 'layout/announcement-bar';
import hero from 'components/hero';
import video from 'components/video';
import quickfinder from 'components/quickfinder';
import usp from 'components/usp';
import carousel from 'components/carousel';
import featuredArticles from 'components/featured-articles';
import instagram from 'components/instagram';
import quicklinks from 'components/quicklinks';
import mobileNavigation from 'components/mobile-navigation';
import scrollbar from 'components/scrollbar';
import accordion from 'components/accordion';
import cartDrawer from 'components/cart-drawer';
import productItem from 'components/product-item';
import cartUpsell from 'components/cart-upsell';
import cartTerms from 'components/cart-terms';
import search from 'components/search';
import searchOverlay from 'components/search-overlay';
import videoPlayer from 'components/video-player';
import geoSelector from 'components/geo-selector';
import geoPopup from 'components/geo-popup';
import gorgias from 'components/gorgias';

const app = picoapp({
  header,
  'announcement-bar': announcementBar,
  hero,
  video,
  'video-player': videoPlayer,
  quickfinder,
  usp,
  carousel,
  'featured-articles': featuredArticles,
  instagram,
  quicklinks,
  'navigation-mobile': mobileNavigation,
  scrollbar,
  accordion,
  'cart-drawer': cartDrawer,
  'product-item': productItem,
  'cart-upsell': cartUpsell,
  'cart-terms': cartTerms,
  search,
  'search-overlay': searchOverlay,
  'geo-selector': geoSelector,
  'geo-popup': geoPopup,
  gorgias,
}, {});

ready(() => app.mount());
app.on('app:remount', () => app.mount());

export default app;
